import { BaseApiService } from '../base/BaseApiService';
import {
  CreatePlanRequest,
  UpdatePlanRequest,
  PlanResponse
} from '../../types/dtos';
import { ApiResponse, PaginationParams, PaginatedResponse } from '../../types/api';

export class PlanService extends BaseApiService {
  // Buscar todos os planos (sem paginação)
  async getAllPlans(): Promise<PlanResponse[]> {
    const response = await this.api.get<PlanResponse[]>('/plans');
    return response.data;
  }

  // Buscar planos com paginação
  async getPlans(params?: PaginationParams): Promise<PaginatedResponse<PlanResponse>> {
    const response = await this.api.get<ApiResponse<PaginatedResponse<PlanResponse>>>('/plans', { params });
    return this.extractData(response);
  }

  // Buscar plano por ID
  async getPlanById(id: string): Promise<PlanResponse> {
    const response = await this.api.get<PlanResponse>(`/plans/${id}`);
    return response.data;
  }

  // Buscar plano por nome
  async getPlanByName(name: string): Promise<PlanResponse> {
    const response = await this.api.get<PlanResponse>(`/plans/by-name/${encodeURIComponent(name)}`);
    return response.data;
  }

  // Buscar planos por faixa de preço
  async getPlansByPriceRange(minPrice: number, maxPrice: number): Promise<PlanResponse[]> {
    const response = await this.api.get<PlanResponse[]>(`/plans/by-price-range?minPrice=${minPrice}&maxPrice=${maxPrice}`);
    return response.data;
  }

  // Buscar planos por franquia de dados
  async getPlansByDataAllowance(minDataMb: number, maxDataMb: number): Promise<PlanResponse[]> {
    const response = await this.api.get<PlanResponse[]>(`/plans/by-data-allowance?minDataMb=${minDataMb}&maxDataMb=${maxDataMb}`);
    return response.data;
  }

  // Criar plano
  async createPlan(planData: CreatePlanRequest): Promise<PlanResponse> {
    const response = await this.api.post<PlanResponse>('/plans', planData);
    return response.data;
  }

  // Atualizar plano
  async updatePlan(id: string, planData: UpdatePlanRequest): Promise<void> {
    await this.api.put(`/plans/${id}`, planData);
  }

  // Deletar plano
  async deletePlan(id: string): Promise<void> {
    await this.api.delete(`/plans/${id}`);
  }

  // Estatísticas
  async getAveragePrice(): Promise<number> {
    const response = await this.api.get<{ averagePrice: number }>('/plans/statistics/average-price');
    return response.data.averagePrice;
  }

  async getCheapestPlan(): Promise<PlanResponse> {
    const response = await this.api.get<PlanResponse>('/plans/statistics/cheapest');
    return response.data;
  }

  async getMostExpensivePlan(): Promise<PlanResponse> {
    const response = await this.api.get<PlanResponse>('/plans/statistics/most-expensive');
    return response.data;
  }
}

// Instância singleton
export const planService = new PlanService();
